import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './archived-files.styles'
import ArchivedFilesTable from './archived-files-table/archived-files-table.container'
import CurrentSkeleton from './archived-files-skeleton/current-skeleton'
import octopus from './octopus.png'

class ArchivedFiles extends Component {
  componentDidMount() {
    this.props.onMount()
  }
  render() {
    const { classes, pending, noFiles } = this.props
    return noFiles ? (
      <div>
        <img src={octopus} className={classes.illustration} alt="Not Found" />
        <p className={classes.container}>
          You don't have archived moderation files. <br />
        </p>
      </div>
    ) : pending ? (
      <CurrentSkeleton />
    ) : (
      <ArchivedFilesTable />
    )
  }
}

export default injectSheet(styles)(ArchivedFiles)
